import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";

const EditItemModal = ({ isOpen, itemData, onChange, onClose, onSave }) => {
  const [placeInput, setPlaceInput] = useState(itemData.place || "");
  const [placeOptions, setPlaceOptions] = useState([]);

  useEffect(() => {
    const fetchPlaces = async () => {
      if (!placeInput || placeInput.length < 2) return;
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/trips/google_places?query=${placeInput}`);
        const data = await res.json();
        setPlaceOptions(data);
      } catch (err) {
        console.error("Place search error:", err);
      }
    };

    const debounce = setTimeout(fetchPlaces, 300);
    return () => clearTimeout(debounce);
  }, [placeInput]);

  const handlePlaceSelect = (place) => {
    setPlaceInput(place.name);
    onChange("place", place.name);  // 只傳地點名，後端會補完整資訊
	onChange("details", place.formatted_address);         // 詳細地址寫入 Details 欄位
    setPlaceOptions([]);
  };	
	
  const handleChange = (field) => (e) => {
    onChange(field, e.target.value);
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
	  className="modal-content w-full max-w-lg mx-auto mt-20 sm:mt-24 rounded-xl border border-accent outline-none bg-white shadow-xl"
	  overlayClassName="modal-backdrop flex justify-center items-start"
    >
      <h2 className="text-xl sm:text-2xl font-bold text-primary mb-4">Add/Edit Item</h2>

      <input
        type="date"
        className="form-input mb-2"
        value={itemData.date || ""}
        onChange={handleChange("date")}
      />

      <input
        type="text"
        placeholder="Location"
        className="form-input mb-2"
        value={itemData.place || placeInput}
        onChange={(e) => {
          setPlaceInput(e.target.value);
          onChange("place", e.target.value); // 用戶輸入仍更新原值，後端 fallback
        }}
      />
      {placeOptions.length > 0 && (
        <div className="bg-white border border-gray-300 rounded shadow mb-2 max-h-40 overflow-y-auto text-sm">
          {placeOptions.map((place) => (
            <div
              key={place.place_id}
              className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => handlePlaceSelect(place)}
            >
              <strong>{place.name}</strong>
              <div className="text-sm text-gray-500">{place.formatted_address}</div>
            </div>
          ))}
        </div>
      )}
      <select
        className="form-input mb-2"
        value={itemData.type || ""}
        onChange={handleChange("type")}
      >
        <option value="">Select type</option>
        <option value="sightseeing">Sightseeing</option>
        <option value="commute">Commute</option>
        <option value="dining">Dining</option>
        <option value="shopping">Shopping</option>
        <option value="lodging">Lodging</option>
		<option value="flight">Flight</option>
      </select>

      <textarea
        placeholder="Details"
        className="form-input mb-2"
        value={itemData.details || ""}
        onChange={handleChange("details")}
      />

      <div className="flex flex-col sm:flex-row gap-2 mb-2">
        <input
          type="time"
          className="form-input sm:w-1/2"
          value={itemData.start_time || ""}
          onChange={handleChange("start_time")}
        />
        <input
          type="time"
          className="form-input sm:w-1/2"
          value={itemData.end_time || ""}
          onChange={handleChange("end_time")}
        />
      </div>

      <input
        type="number"
        step="0.01"
        placeholder="Estimated cost"
        className="form-input mb-2"
        value={itemData.cost || ""}
        onChange={handleChange("cost")}
      />

      <input
        type="text"
        placeholder="URL"
        className="form-input mb-4"
        value={itemData.url || ""}
        onChange={handleChange("url")}
      />

      <div className="modal-actions flex justify-end sm:flex-row flex-col gap-2">
        <button
          className="btn-full bg-gray-300 text-sm rounded hover:bg-gray-400"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className="btn-full bg-primary text-white text-sm rounded hover:bg-orange-600"
          onClick={onSave}
        >
          Save
        </button>
      </div>
    </ReactModal>
  );
};

export default EditItemModal;
